import React from 'react';
import { ActivityPost } from '@components/feed/Feed/components/ActivityPost';
import { IInstructionPagePublishedActivity } from './interfaces';
import { Trans } from 'react-i18next';
import { CardMedia } from '@mui/material';
import { ROUTES } from '@routes/routes';
import { useNavigate } from 'react-router';
import MenuBookIcon from '@mui/icons-material/MenuBook';

export const InstructionPagePublishedActivity: React.FC<
  IInstructionPagePublishedActivity
> = ({ title, date, slug, coverImageId }): JSX.Element => {
  const navigate = useNavigate();

  const activityTitle = (
    <Trans
      i18nKey={'activities:instructionPagePublished.title'}
      values={{
        title,
      }}
      components={{
        bold: <strong />,
      }}
    />
  );

  return (
    <ActivityPost
      title={activityTitle}
      date={date}
      icon={MenuBookIcon}
      onClick={() =>
        navigate(ROUTES.portal.association.instructions.details(slug))
      }
    >
      {coverImageId && (
        <CardMedia component="img" image={ROUTES.images.image(coverImageId)} />
      )}
    </ActivityPost>
  );
};
